import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import { colors, fonts, A, easingSeconds, boxShadow } from "../shared";

const LinkA = styled(A)`
    &,
    &:visited {
        color: ${({ isHeroSearchV2 }) =>
            isHeroSearchV2 ? colors.brownishGrey : colors.whiteDuplicate};
        text-decoration: none;
        font-size: 0.875rem;
        transition: all ${easingSeconds};

        &:hover {
            color: ${({ isHeroSearchV2 }) =>
                isHeroSearchV2 ? colors.darkTwo : fonts.fontColors.light.link};
            text-decoration: underline;
        }
    }
`;

let Link = ({ children, className, ...anchorProps }) => (
    <li className={className}>
        <LinkA {...anchorProps}>{children}</LinkA>
    </li>
);

Link = styled(Link)``;

Link.propTypes = {
    href: PropTypes.string,
    onClick: PropTypes.func
};

export { Link };

export const Wrapper = styled.nav`
    position: absolute;
    left: 0;
    z-index: 100;
    background-color: ${({ isHeroSearchV2 }) =>
        isHeroSearchV2 ? colors.whiteDuplicate : colors.dark};
    width: 13.125rem;
    padding: 1.6875rem 1.875rem 1.8125rem;

    ${({ isHeroSearchV2 }) => isHeroSearchV2 && `box-shadow: ${boxShadow}`};

    ${Link} {
        &:not(:last-of-type) {
            margin-bottom: 1.5rem;
        }
    }
`;
